import {
  createTranslationMessages,
  createTranslationResource,
} from '@backstage/frontend-plugin-api';
import { orgTranslationRef } from '@backstage/plugin-org';

/**
 * Partial `en` message overrides for `@backstage/plugin-org`.
 *
 * `full: false` means every key not listed here keeps its upstream default,
 * so this file only ever changes the one label below.
 */
export const orgMessages = createTranslationMessages({
  ref: orgTranslationRef,
  full: false,
  messages: {
    'ownershipCard.aggregateRelationsToggle.label':
      "Include child teams' ownership",
  },
});

/**
 * Overrides the EntityOwnershipCard toggle label.
 *
 * Upstream default is "Include indirect ownership", which is Backstage
 * jargon. "Include child teams' ownership" states in plain language what
 * the toggle actually does (aggregate ownership from descendant groups).
 * Behaviour is unchanged — label text only.
 */
export const orgTranslations = createTranslationResource({
  ref: orgTranslationRef,
  translations: {
    en: () => Promise.resolve({ default: orgMessages }),
  },
});
